import { render, staticRenderFns } from "./Tagging.vue?vue&type=template&id=2664e365&scoped=true"
import script from "./Tagging.vue?vue&type=script&lang=js"
export * from "./Tagging.vue?vue&type=script&lang=js"
import style0 from "./Tagging.vue?vue&type=style&index=0&id=2664e365&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2664e365",
  null
  
)

export default component.exports